<div class="qa-text-options">
  <h4>{{_(KEYS.EDITOR.VALIDATION)}}</h4>
  <section class="qa-validation-group" #regexEl>
    <div class="qa-validation-header">
      <label [attr.for]="'qa-regex-' + question.id">{{_(KEYS.EDITOR.REGULAR_EXPRESSION)}}</label>
      <div class="qa-validation-actions">
        <button type="button" class="qa-validation-action qa-validation-save"
                [ngbTooltip]="_(KEYS.EDITOR.SAVE)" [attr.aria-label]="_(KEYS.EDITOR.SAVE)"
                (click)="onSaveRegex(regexEl)" [disabled]="!regex || !isRegexDirty()">
          <i class="fa fa-save" aria-hidden="true"></i>
        </button>
        <button type="button" class="qa-validation-action"
                [ngbTooltip]="_(KEYS.EDITOR.RESET)" [attr.aria-label]="_(KEYS.EDITOR.RESET)"
                (click)="onResetRegex(regexEl)" [disabled]="!isRegexDirty()">
          <i class="fa fa-undo" aria-hidden="true"></i>
        </button>
        <button type="button" class="qa-validation-action qa-validation-delete"
                [ngbTooltip]="_(KEYS.EDITOR.REMOVE)" [attr.aria-label]="_(KEYS.EDITOR.REMOVE)"
                (click)="onDeleteRegex()"
                [disabled]="!regex && !mod && !question.options.validation.regex && !question.options.validation.mod">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="qa-regex-fields">
      <input class="form-control" type="text" [id]="'qa-regex-' + question.id"
             [placeholder]="_(KEYS.EDITOR.REGULAR_EXPRESSION)" [(ngModel)]="regex" />
      <input class="form-control" type="text" placeholder="Mod." [attr.aria-label]="_(KEYS.EDITOR.REGEX_MODIFIERS)"
             [ngbTooltip]="_(KEYS.EDITOR.REGEX_MODIFIERS)" [(ngModel)]="mod" />
    </div>
  </section>
  <section class="qa-validation-group" #hintEl>
    <div class="qa-validation-header">
      <label [attr.for]="'qa-validation-hint-' + question.id">{{_(KEYS.EDITOR.HINT)}}</label>
      <div class="qa-validation-actions">
        <button type="button" class="qa-validation-action qa-validation-save"
                [ngbTooltip]="_(KEYS.EDITOR.SAVE)" [attr.aria-label]="_(KEYS.EDITOR.SAVE)"
                (click)="onSaveHint(hintEl)" [disabled]="!isHintDirty()">
          <i class="fa fa-save" aria-hidden="true"></i>
        </button>
        <button type="button" class="qa-validation-action"
                [ngbTooltip]="_(KEYS.EDITOR.RESET)" [attr.aria-label]="_(KEYS.EDITOR.RESET)"
                (click)="onResetHint(hintEl)" [disabled]="!isHintDirty()">
          <i class="fa fa-undo" aria-hidden="true"></i>
        </button>
        <button type="button" class="qa-validation-action qa-validation-delete"
                [ngbTooltip]="_(KEYS.EDITOR.REMOVE)" [attr.aria-label]="_(KEYS.EDITOR.REMOVE)"
                (click)="onDeleteHint()" [disabled]="!hint && !question.options.validation.hint[locale]">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <textarea class="form-control qa-validation-hint" rows="3" wrap="soft"
              [id]="'qa-validation-hint-' + question.id" [placeholder]="_(KEYS.EDITOR.HINT)"
              [value]="hint" (input)="onHintInput($event)" (keydown.enter)="$event.preventDefault()"
              (beforeinput)="onHintBeforeInput($event)"></textarea>
  </section>
  <div class="multiline-options" *ngIf="question.options.multiline">
    <h4>{{_(KEYS.EDITOR.INPUT_OPTIONS)}}</h4>
    <label class="qa-text-toggle">
      <input type="checkbox" [(ngModel)]="question.options.html">
      <span>{{_(KEYS.EDITOR.ALLOW_HTML)}}</span>
    </label>
  </div>
</div>
